export default __webpack_public_path__ + "static/media/vertical-colorful.92c4426d.png";